import { AccessibilityHelpers } from 'js/components/Util/Accessibility.js';
const createFocusTrap = require('focus-trap/index.js');

let accessibilityHelpersInstance = new AccessibilityHelpers();

export class Header {
  constructor(mobileBP = 767) {
    this.headerEl = document.getElementById('Header');
    this.menuOverlayEl = this.headerEl.querySelector('.Header-overlay');
    this.navEl = this.headerEl.querySelector('.Header-content');
    this.menuEl = this.headerEl.querySelector('.Header-menu');
    this.menuBtnEl = this.headerEl.querySelector('.Header-toggleIcon');
    this.menuCloseBtn = this.headerEl.querySelector('.Header-closeIcon');
    this.menuItems = this.headerEl.querySelectorAll('.Header-menuItem a');
    this.hasBeenSetupMobile = false;
    this.mobileBP = window.matchMedia(`(max-width: ${mobileBP}px)`);
    this.wasDesktop = !this.mobileBP.matches;
    this.focusTrap = createFocusTrap('#Header', {
      onActivate: () => {
        this.handleHeaderTabIndexes(0);
      },
      onDeactivate: () => {
        this.handleHeaderTabIndexes(-1);
      },
    });

    this.handleMobileHeader();
    this.mobileBP.addListener(this.handleMobileHeader.bind(this));
  }

  handleMobileHeader() {
    if (this.mobileBP.matches) {
      this.enableMobileHeader();
    } else {
      this.resetMobileHeader();
    }
  }

  enableMobileHeader() {
    const closeMenu = () => {
      this.navEl.style['width'] = '0px';
        if (this.menuOverlayEl) {
          this.menuOverlayEl.style['opacity'] = '0';
          window.setTimeout(() => {
            this.menuOverlayEl.style['display'] = 'none';
          }, 300); // matches opacity transition time
        }
        this.focusTrap.deactivate();
    }

    const headerLogic = () => {
      if (this.menuOverlayEl) {
        this.menuOverlayEl.style['display'] = 'block';
      }
      document.body.classList.toggle('noOverflow');
      document.documentElement.classList.toggle('noOverflow');

      this.navEl.style['width'] = '360px';
      if (this.menuOverlayEl) {
        this.menuOverlayEl.style['opacity'] = '1';
      }
      this.focusTrap.activate();

      accessibilityHelpersInstance.toggleAriaState(this.navEl, 'hidden');
      accessibilityHelpersInstance.toggleAriaState(this.menuBtnEl, 'expanded');
      accessibilityHelpersInstance.toggleAriaState(this.menuOverlayEl, 'hidden');
      if (this.menuOverlayEl) {
        accessibilityHelpersInstance.toggleAriaState(this.menuOverlayEl, 'expanded');
      }

    };

    this.handleHeaderTabIndexes(-1);
    accessibilityHelpersInstance.setAriaProp(this.navEl, 'hidden', true);

    if (!this.hasBeenSetupMobile) {
      this.menuBtnEl.addEventListener('click', headerLogic);
      if (this.menuOverlayEl) {
        this.menuOverlayEl.addEventListener('click', headerLogic);
      }
      if(this.menuCloseBtn)
        this.menuCloseBtn.addEventListener('click', closeMenu);
      this.hasBeenSetupMobile = true;
    }
    this.wasDesktop = false;
  }

  resetMobileHeader() {
    if (!this.wasDesktop) {
      this.headerEl.classList.remove('isOpen');
      this.navEl.style = '';
      accessibilityHelpersInstance.setAriaProp(this.navEl, 'hidden', false);
      this.focusTrap.deactivate();
      this.handleHeaderTabIndexes(0);
      this.wasDesktop = true;
    }
  }

  handleHeaderTabIndexes(tabIndex) {
    accessibilityHelpersInstance.setTabIndex(this.menuItems, tabIndex);
    if (this.menuOverlayEl) {
      accessibilityHelpersInstance.setTabIndex(this.menuOverlayEl, tabIndex);
    }
  }
}
